import { Language } from './i18n';

// Interface for ticker content in different languages
interface TickerContent {
  content_ja: string[];
  content_de: string[];
}

/**
 * Retrieves ticker content for the specified language
 * @param language - Language code (ja/de)
 */
export async function getTickerContent(language: Language): Promise<string[]> {
  try {
    const response = await fetch('/content/ticker/content.json');
    if (!response.ok) {
      throw new Error('Failed to load ticker content');
    }
    const data: TickerContent = await response.json();
    return language === 'de' ? data.content_de : data.content_ja;
  } catch (error) {
    console.error('Error loading ticker content:', error);
    return [];
  }
}